import React, { useMemo } from 'react';
import PreloaderComponent from '#component/preloader';
import NotFoundMessage from '#component/general/not-found-message';
import ConfigurableTable from '#component/table/configurable-table/configurable-table';
import propTypes from './prop-types';
import { tableNameType } from '#type';

const TableView = props => {
  const {
    projects,
    account,
    loading
  } = props;

  const tableHeadProps = useMemo(() => ({
    account
  }), [account]);

  const tableBodyProps = useMemo(() => ({
    loading,
    withoutHover: true
  }), [loading]);

  if (!projects.length && loading) {
    return <PreloaderComponent />;
  }

  if (!loading && !projects.length) {
    return (
      <NotFoundMessage style={{ marginTop: -50 }}>
        No projects
      </NotFoundMessage>
    );
  }

  return (
    <ConfigurableTable
      data={projects}
      headCellProps={tableHeadProps}
      bodyCellProps={tableBodyProps}
      tableName={tableNameType.PROJECT_TABLE}
    />
  );
};

TableView.propTypes = propTypes;

export default TableView;
